"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserFullName = void 0;
const getUserFullName = (first_name, last_name) => {
    return `${first_name || ""} ${last_name || ""}`;
};
exports.getUserFullName = getUserFullName;
//# sourceMappingURL=userUtils.js.map